import { useFormContext, Controller, UseFormTrigger } from 'react-hook-form';
import { AppInputBase, AppInputBaseProps } from './app-input-base';

//
//

export type AppInputProps = AppInputBaseProps & {
  name: string;
  hideZero?: boolean;
  onRevalidate?: UseFormTrigger<any>;
};

export const AppInput = ({
  name,
  helperText,
  hideZero,
  children,
  onRevalidate,
  ...props
}: AppInputProps) => {
  const { control } = useFormContext();

  //

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const displayValue =
          hideZero && (field.value === 0 || field.value == null) ? '' : field.value ?? '';

        return (
          <AppInputBase
            error={!!fieldState.error}
            id={'input-' + field.name}
            value={displayValue}
            onChange={(newValue) => {
              field.onChange(newValue);

              if (onRevalidate) {
                onRevalidate();
              }
            }}
            onBlur={field.onBlur}
            inputRef={field.ref}
            helperText={fieldState.error?.message || helperText}
            FormHelperTextProps={{ style: { marginLeft: 0 } }}
            {...props}
          >
            {children}
          </AppInputBase>
        );
      }}
    />
  );
};
